module.exports = __webpack_public_path__ + "static/media/21ECLAC45.cfcbbdb0.jpg";